import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnDestroy,
} from '@angular/core';

@Component({
  selector: 'app-popup',
  standalone: true,
  imports: [],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss',
})
export class PopupComponent implements OnInit, OnDestroy {
  @Input({ required: true }) heading!: string;
  @Input() confirmText!: string;
  @Input() cancelText!: string;
  @Input() popupPosition = 'fixed';
  @Input() showFooterButtons = true;
  @Input() isConfirmDisabled = false;
  @Input() showCloseIcon = false;
  @Input() isFullScreen = false;

  @Output() cancelClicked = new EventEmitter<boolean>();
  @Output() confirmClicked = new EventEmitter();

  private originalBodyOverflow = '';

  ngOnInit(): void {
    this.disableBackgroundScroll();
  }

  ngOnDestroy(): void {
    this.enableBackgroundScroll();
  }

  private disableBackgroundScroll(): void {
    this.originalBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  private enableBackgroundScroll(): void {
    document.body.style.overflow = this.originalBodyOverflow;
  }

  onConfirm(): void {
    this.confirmClicked.emit();
  }

  onCancel(closePopup = false): void {
    this.cancelClicked.emit(closePopup);
  }
}
